\rtr-short-article,
\rtr-short-article-list,
\rtr-short-article-list-skeleton
    width: 100%
    max-width: 100%
    box-sizing: border-box
    position: relative

.ArticleListContainer
    width: 100%
    max-width: 100%
    min-height: 100px
    padding: 0 20px
    display: flex
    flex-direction: column
    justify-content: space-between
    align-items: center
    gap: 10px
    box-sizing: border-box
    font-size: 12px
    position: relative
    .ArticleImg
        width: auto
        max-width: 240px
        max-height: 135px
        object-fit: cover
        cursor: pointer
        border-radius: $globalButtonRounding
        flex-shrink: 0
    .TitleContainer
        display: flex
        flex-direction: column
    .ArticleContainerImageContent
        min-width: 30%
        max-width: 100%
        display: flex
        flex-direction: column
        align-items: center
        gap: 20px
    .ArticleContainerContent
        min-width: 0
        max-width: 100%
        display: flex
        flex-direction: column
        align-items: flex-start
        box-sizing: border-box
        font-size: 12px
    .ArticleContainerImage
        align-self: center
    .Title
        font-size: 18px
        font-weight: 700
        cursor: pointer
    .UnderTitle
        min-width: 0
        max-width: 100%
        font-size: 14px
        cursor: pointer
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
    .NotAvailableHint
        font-weight: 700
        color: rgb($globalSettingsFontSecondary)
    .Description
        line-height: 1.4
        max-height: 4.2em
        overflow: hidden
        text-align: left
        text-overflow: ellipsis
        display: -webkit-box
        -webkit-line-clamp: 3
        -webkit-box-orient: vertical
    .ActionContainer
        width: 100%
        max-width: 100%
        display: flex
        flex-direction: row
        align-items: center
        justify-content: space-between
        gap: 10px
    .AdditionalActionContainer
        width: 100%
        display: flex
        flex-direction: row
        align-items: flex-end
        justify-content: space-between
        gap: 10px
    .PriceContainer
        font-size: 14px
        font-weight: 700
    .ActionInfoContainer
        display: flex
        flex-direction: column
    .SearchButtonContainer
        display: flex
        flex-direction: column
        align-items: flex-end
    .BookingContainer
        width: 100%
        display: flex
        flex-direction: row
        justify-content: flex-end
        align-items: center
        flex-wrap: wrap
        gap: 20px
    .AvailabilityLink
        color: rgb($globalSettingsFontSecondary)
        text-decoration: underline
        cursor: pointer
    .SkeletonImg
        width: 120px
        height: 90px
        background: rgb($globalSettingsBackgroundSecondary)
        padding-top: 5px
        box-sizing: border-box
    .SkeletonTitle
        width: 50%
        height: 20.5px
        background: rgb($globalSettingsBackgroundSecondary)
        border-radius: $globalButtonRounding
    .SkeletonUnderTitle
        width: 70%
        height: 15.5px
        background: rgb($globalSettingsBackgroundSecondary)
        border-radius: $globalButtonRounding
    .SkeletonDescription
        width: 100%
        height: 50.4px
        background: rgb($globalSettingsBackgroundSecondary)
        border-radius: $globalButtonRounding
    .SkeletonPrice
        width: 110px
        height: 24.5px
        background: rgb($globalSettingsBackgroundSecondary)
        border-radius: $globalButtonRounding
    .SkeletonButton
        width: 200px
        height: 40px
        background: rgb($globalSettingsBackgroundSecondary)
        border-radius: $globalButtonRounding

@media #{$tablet}
    .ArticleListContainer
        width: 100%
        flex-direction: row
        gap: 20px
        .ArticleContainerImageContent
            flex-grow: 1
            flex-direction: row
        .Description
            width: 100%
        .ActionContainer
            width: 200px
            flex-direction: column
            align-items: flex-end
            justify-content: flex-end
            align-self: flex-end
            flex-shrink: 0
        .ActionInfoContainer
            align-items: flex-end
        .ArticleImg
            max-width: 100px
            max-height: 80px
        .ChildHalfWidth
            &>*
                width: 50%
